import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getJournal = (params) => api.get("/journal", { params }).then((r) => r.data);
export const getArticle = (slug) => api.get(`/journal/${slug}`).then((r) => r.data);
export const subscribe = (payload) => api.post("/newsletter/subscribe", payload).then((r) => r.data);
export const getFunnels = () => api.get("/funnels").then((r) => r.data);
export const getFunnel = (slug) => api.get(`/funnels/${slug}`).then((r) => r.data);
export const trackFunnel = (slug, event, variant, source) => api.post(`/funnels/${slug}/track`, { event, variant: variant || "", source: source || "" }).then((r) => r.data).catch(() => {});
export const getFunnelAnalytics = () => api.get("/admin/funnels/analytics").then((r) => r.data);
export const getFunnelSources = () => api.get("/admin/funnels/sources").then((r) => r.data);
export const getFunnelConfig = (slug) => api.get(`/admin/funnels/${slug}/config`).then((r) => r.data);
export const setFunnelConfig = (slug, cfg) => api.put(`/admin/funnels/${slug}/config`, cfg).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const checkout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const paymentStatus = (id) => api.get(`/payments/status/${id}`).then((r) => r.data);
export const downloadManifest = (id) => api.get(`/download/${id}/manifest`).then((r) => r.data);
export const accountPurchases = () => api.get("/account/purchases").then((r) => r.data);

export const adminLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const memberRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const memberLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const getRecipes = () => api.get("/daily-recipes").then((r) => r.data);
export const getRecipe = (slug) => api.get(`/daily-recipes/${slug}`).then((r) => r.data);
export const getStore = (params) => api.get("/store", { params }).then((r) => r.data);
export const checkoutStore = (payload) => api.post("/payments/checkout-store", payload).then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminOrders = () => api.get("/admin/orders").then((r) => r.data);
export const adminSubscribers = () => api.get("/admin/subscribers").then((r) => r.data);
export const adminMessages = () => api.get("/admin/messages").then((r) => r.data);
export const adminCreateProduct = (p) => api.post("/admin/products", p).then((r) => r.data);
export const adminUpdateProduct = (slug, p) => api.put(`/admin/products/${slug}`, p).then((r) => r.data);
export const adminDeleteProduct = (slug) => api.delete(`/admin/products/${slug}`).then((r) => r.data);
export const adminCreateArticle = (a) => api.post("/admin/journal", a).then((r) => r.data);
export const adminDeleteArticle = (slug) => api.delete(`/admin/journal/${slug}`).then((r) => r.data);

// AgnesAI
export const agnesAccess = () => api.get("/agnes/access").then((r) => r.data);
export const agnesGetPantry = () => api.get("/agnes/pantry").then((r) => r.data);
export const agnesReplacePantry = (items) => api.put("/agnes/pantry", { items }).then((r) => r.data);
export const agnesAddPantry = (item) => api.post("/agnes/pantry", item).then((r) => r.data);
export const agnesRemovePantry = (id) => api.delete(`/agnes/pantry/${id}`).then((r) => r.data);
export const agnesListSessions = () => api.get("/agnes/sessions").then((r) => r.data);
export const agnesCreateSession = () => api.post("/agnes/sessions").then((r) => r.data);
export const agnesGetSession = (sid) => api.get(`/agnes/sessions/${sid}`).then((r) => r.data);
export const agnesDeleteSession = (sid) => api.delete(`/agnes/sessions/${sid}`).then((r) => r.data);
export const agnesChat = (payload) => api.post("/agnes/chat", payload).then((r) => r.data);
export const agnesGetShopping = () => api.get("/agnes/shopping-list").then((r) => r.data);
export const agnesAddShopping = (item) => api.post("/agnes/shopping-list", item).then((r) => r.data);
export const agnesToggleShopping = (id, checked) => api.put(`/agnes/shopping-list/${id}`, { checked }).then((r) => r.data);
export const agnesRemoveShopping = (id) => api.delete(`/agnes/shopping-list/${id}`).then((r) => r.data);
export const agnesClearCheckedShopping = () => api.post("/agnes/shopping-list/clear-checked").then((r) => r.data);
export const agnesGenerateMealPlan = (preferences) => api.post("/agnes/meal-plan/generate", { preferences }).then((r) => r.data);
export const agnesListMealPlans = () => api.get("/agnes/meal-plans").then((r) => r.data);
export const agnesGetMealPlan = (id) => api.get(`/agnes/meal-plans/${id}`).then((r) => r.data);
export const agnesDeleteMealPlan = (id) => api.delete(`/agnes/meal-plans/${id}`).then((r) => r.data);
export const agnesMealPlanToShopping = (id) => api.post(`/agnes/meal-plans/${id}/to-shopping`).then((r) => r.data);
export const agnesGetWhisper = () => api.get("/agnes/whisper").then((r) => r.data);
export const agnesSetWhisperEmail = (opt_in) => api.put("/agnes/whisper/email", { opt_in }).then((r) => r.data);
export const agnesGetGarden = () => api.get("/agnes/garden").then((r) => r.data);
export const agnesAddGarden = (entry) => api.post("/agnes/garden", entry).then((r) => r.data);
export const agnesRemoveGarden = (id) => api.delete(`/agnes/garden/${id}`).then((r) => r.data);
export const agnesGetGardenReminders = () => api.get("/agnes/garden/reminders").then((r) => r.data);
export const agnesGetTodayMeal = () => api.get("/agnes/today-meal").then((r) => r.data);
export const agnesCookTonight = () => api.post("/agnes/cook-tonight").then((r) => r.data);
export const agnesSetDigestEmail = (opt_in) => api.put("/agnes/digest/email", { opt_in }).then((r) => r.data);
export const agnesDigestSendNow = () => api.post("/agnes/digest/send-now").then((r) => r.data);
